import { ProjectData } from "../sidebar/project";

import { VerificationCertificate } from "./VerificationCertificate";
import { MuteAnt } from "./MuteAnt";
import { Donald } from "./Donald";

export function getProjects(): ProjectData[] {
  return [VerificationCertificate(), MuteAnt(), Donald()];
}
